
<div>
    <v-icon
        :color="value ? 'primary' : 'secondary-lighten-3'"
        size="18"
    >
        {{ icon }}
    </v-icon>
</div>
